/**
 * 公共配置文件
 */
import $baseConfig from '@src/_common/config'

const isDev = process.env.VUE_APP_ENV_NAME === 'development'
const isTest = process.env.VUE_APP_ENV_NAME === 'test'


const configDict = {
	development: {
		appId: '1096262626481082371',
		baseURL: $baseConfig.baseURL_test,
		oAUrl: $baseConfig.oaUrl_test,
	},
	test: {
		appId: '1096262626481082371',
		baseURL: $baseConfig.baseURL_test,
		oAUrl: $baseConfig.oaUrl_test,
	},
	uat: {
		appId: '1096262626481082371',
		baseURL: 'http://uat.api.newhope.cn',
		oAUrl: $baseConfig.oaUrl_test,
	},
	production: {
		appId: '1096262626481082371',
		baseURL: $baseConfig.baseURL,
		oAUrl: $baseConfig.oaUrl,
	}
}

const currentConfigKey = process.env.VUE_APP_ENV_NAME

const configObj = {
	appCode: '',
	isDevelop: (isDev || isTest),
	...configDict[currentConfigKey],
	defaultAuthorization: 'Basic cG9ydGFsOnBvcnRhbA==',
	loginUrl: configDict[currentConfigKey].oAUrl + '/login?service=http://api.fat.nhdc.com/auth/oasso/loginBack?redirect=',
	oaLogout: configDict[currentConfigKey].oAUrl + '/logout',
	// 公共页面配置
	paginationSize: 10, // 页面表格每页显示条数
	paginationPages: [10, 20, 30, 40, 60, 80, 100],
}

export default configObj
